import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import * as firebase from 'firebase';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
//import { AdmobFreeService } from './service/admobfree.service.ts.service';
//import { AdMobFree } from '@ionic-native/admob-free/ngx';


firebase.initializeApp({
  apiKey: "AIzaSyAEQlt-t5tpNaSub26Jsul2Bixg9HpeHcg",
  authDomain: "pliroforiki-6b464.firebaseapp.com",
  databaseURL: "https://pliroforiki-6b464.firebaseio.com",
  projectId: "pliroforiki-6b464",
  storageBucket: "pliroforiki-6b464.appspot.com",
  messagingSenderId: "989127666048",
  appId: "1:989127666048:web:5bd444efcfdf5cc23ef965",
  measurementId: "G-HZ459JZSC0"
});
firebase.analytics();


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule, ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

